import axios from "../api/axios";

export const getCompanyProfile = async () => {
  const response = await axios.get("settings/company-profile");
  return response.data;
};

export const saveCompanyProfile = async (formData) => {
  const response = await axios.post("settings/company-profile", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
